import { createIcon } from '@chakra-ui/react';

export const MbePackage = createIcon({
  displayName: 'MbePackage',
  viewBox: '0 0 124 104',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="4">
        <path d="M116.314 29.94 67.223 3.324a10.97 10.97 0 0 0-10.448 0L7.684 29.94A10.833 10.833 0 0 0 2 39.46v25.08c0 3.968 2.18 7.62 5.684 9.52l49.09 26.617a10.97 10.97 0 0 0 10.449 0l49.09-26.616A10.837 10.837 0 0 0 122 64.538v-25.08c0-3.965-2.182-7.617-5.686-9.518z" />
        <path d="M95.863 19.468 40.412 49.227c-3.505 1.9-5.687 5.243-5.687 9.209v31.518" />
        <path d="m30.862 16.757 58.179 31.852c3.504 1.9 5.686 5.86 5.686 9.827v26.096M23.817 54.711l-10.909-5.422v13.555l10.91 5.422z" />
      </g>
    </svg>
  ),
});
